import { createSlice } from "@reduxjs/toolkit";

export interface pageHeaderSliceInterface {
  moduleName: string;
  deleteIDs: number[];
}

const initialState: pageHeaderSliceInterface = {
  moduleName: "",
  deleteIDs: [],
};

const pageHeaderSlice = createSlice({
  name: "pageHeader",
  initialState,
  reducers: {
    setModuleName: (state, action) => {
      state.moduleName = action.payload;
    },
    setDeleteIDs: (state, action) => {
      state.deleteIDs = action.payload;
    },
  },
});
export const { setModuleName, setDeleteIDs } = pageHeaderSlice.actions;
export default pageHeaderSlice.reducer;
